/**
 * Sino de mensagem nova, sintetizado na hora (Web Audio): um "ding" curto com harmônicos que se
 * apagam, sem arquivo de som. Rajadas de mensagens tocam uma vez só.
 */
let ctx: AudioContext | null = null;
let last = 0;

/** Parciais do sino: frequência (Hz), volume relativo e duração (s). */
const PARTIALS: Array<[number, number, number]> = [
  [1046.5, 1, 1.5],
  [2093, 0.32, 0.9],
  [1568, 0.22, 1.1],
  [3136, 0.1, 0.5],
];

export function playBell(volume = 0.18) {
  const now = Date.now();
  if (now - last < 1_500) return;
  last = now;
  try {
    ctx ??= new AudioContext();
    if (ctx.state === "suspended") void ctx.resume();
    const t = ctx.currentTime + 0.01;
    const master = ctx.createGain();
    master.gain.value = volume;
    master.connect(ctx.destination);
    for (const [freq, gain, decay] of PARTIALS) {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = freq;
      const env = ctx.createGain();
      env.gain.setValueAtTime(0.0001, t);
      env.gain.exponentialRampToValueAtTime(gain, t + 0.006);
      env.gain.exponentialRampToValueAtTime(0.0001, t + decay);
      osc.connect(env).connect(master);
      osc.start(t);
      osc.stop(t + decay + 0.05);
    }
  } catch {
    // sem áudio (política do navegador ou dispositivo): só os avisos visuais
  }
}
